// src/autogenerated-version.ts
/* DO NOT MODIFY, AUTOGENERATED FILE */

import versionInfo from '../version.json';

export const BUILD   = versionInfo.build;
export const VERSION = versionInfo.version;
export const DATE    = versionInfo.date;
